export default __webpack_public_path__ + "static/media/T18.62046d95.JPG";